import HomeLayoutPc from "pagesPc/layout/HomeLayoutPc";
import AuthLayoutPc from "pagesPc/layout/AuthLayoutPc";
import React, { ComponentType, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LoadingLottiePc from "components/lottieLoading/LoadingLottiePc";
import Factors from "pages/V2/Factors/Factors";

const HomePagePC: ComponentType = lazy(() => import("pagesPc/Home/HomePc"));
const TrackersPagePC: ComponentType = lazy(
  () => import("pagesPc/Home/TrackerPc"),
);
const ServicesPagePc: ComponentType = lazy(
  () => import("pagesPc/Home/ServicesPc"),
);
const FactorPc: ComponentType = lazy(
  () => import("pages/V2/FactorDetail/FactorDetail"),
);
const ReportsPagePC: ComponentType = lazy(
  () => import("pagesPc/Home/ReportsPc"),
);

const StopReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/StopReportPc"),
);
const SpeedReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/SpeedReportPc"),
);
const MovingReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/MovingReportPc"),
);
const FuelReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/FuelReportPc"),
);
const GeoReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/GeoReportPc"),
);
const NavigationReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/NavigationReportPc"),
);
const PowerReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/PowerReportPc"),
);
const StandbyReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/reportsPagesPc/StandbyReportPc"),
);
const LimitationsPcReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/LimitationsPc"),
);
const LimitationsAddPcReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/limitationPagesPc/AddLimitationPc"),
);
const LimitationsEditPcReportPage: ComponentType = lazy(
  () => import("pagesPc/Home/limitationPagesPc/EditLimitationPc"),
);
const ReviewsPagePC: ComponentType = lazy(
  () => import("pagesPc/Home/reviewsPc"),
);

const OpenNavigationPopupPage = lazy(
  () => import("utils/mapModals/OpenNavigationPopup"),
);

const ChatMapPage: ComponentType = lazy(
  () => import("pagesPc/Home/notificationPc/ChatMapPc"),
);

// auth
const LoginPagePc: ComponentType = lazy(
  () => import("../pagesPc/Auth/LoginPc"),
);
const SignupPagePc: ComponentType = lazy(
  () => import("../pagesPc/Auth/SignupPc"),
);
const VerifyPagePc: ComponentType = lazy(
  () => import("../pagesPc/Auth/VerifyPc"),
);
const ForgetPasswordPagePc: ComponentType = lazy(
  () => import("../pagesPc/Auth/ForgerPasswordPc"),
);
const LoginForgetPasswordPagePc: ComponentType = lazy(
  () => import("../pagesPc/Auth/LoginForgetPasswordPc"),
);

const LocationHistoryMapPage: ComponentType = lazy(
  () => import("../pages/Home/BottomTab/maps/LocationHistoryMap"),
);

const PaymentPage: ComponentType = lazy(
  () => import("pages/V2/Payment/Payment"),
);
const SupportPage: ComponentType = lazy(
  () => import("pages/V2/Support/Support"),
);
const PlansPage: ComponentType = lazy(() => import("pages/V2/Plans/Plans"));

const LoginFromBo: ComponentType = lazy(() => import("pages/Auth/LoginFromBo"));
const QuickLoginRedirectPage: ComponentType = lazy(
  () => import("pages/Auth/QuickLoginRedirect"),
);
const OnlineCommandsPage: ComponentType = lazy(
  () => import("pages/V2/OnlineCommands/OnlineCommands"),
);
const OtherAlertsPage: any = lazy(
  () => import("pages/V2/OnlineCommands/OtherAlerts"),
);
const OtherSettingsPage: any = lazy(
  () => import("pages/V2/OnlineCommands/OtherSettings"),
);
const AppRoute = ({ children }: any) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/auth" replace />;
};
const AuthRoute = ({ children }: any) => {
  const token = localStorage.getItem("token");
  return !token ? children : <Navigate to="/home" replace />;
};
const RouterPc = ({ switchTheme, checkFcm }: any) => {
  if (!localStorage.getItem("token")) {
    return (
      <AuthLayoutPc>
        <Suspense fallback={null}>
          <Routes>
            <Route
              path="/auth"
              element={
                <AuthRoute>
                  <LoginPagePc />
                </AuthRoute>
              }
            />
            <Route
              path="/auth/signup"
              element={
                <AuthRoute>
                  <SignupPagePc />
                </AuthRoute>
              }
            />
            <Route
              path="/auth/verify"
              element={
                <AuthRoute>
                  <VerifyPagePc />
                </AuthRoute>
              }
            />
            <Route
              path="/auth/forget-password"
              element={
                <AuthRoute>
                  <ForgetPasswordPagePc />
                </AuthRoute>
              }
            />
            <Route path="/auth/from-bo" element={<LoginFromBo />} />
            <Route
              path="/auth/login-forget-password"
              element={
                <AuthRoute>
                  <LoginForgetPasswordPagePc />
                </AuthRoute>
              }
            />
            <Route path="/r/*" element={<QuickLoginRedirectPage />} />
            <Route path="/contact-us" element={<SupportPage />} />
            <Route path="/pay" element={<PaymentPage />} />
            <Route path="*" element={<Navigate to="/auth" replace />} />
          </Routes>
        </Suspense>
      </AuthLayoutPc>
    );
  } else {
    return (
      <>
        <HomeLayoutPc checkFcm={checkFcm} switchTheme={switchTheme}>
          <Suspense fallback={<LoadingLottiePc />}>
            <Routes>
              <Route path="/auth/from-bo" element={<LoginFromBo />} />
              <Route
                path="/home"
                element={
                  <AppRoute>
                    <HomePagePC />
                  </AppRoute>
                }
              />
              <Route
                path="/trackers"
                element={
                  <AppRoute>
                    <TrackersPagePC />
                  </AppRoute>
                }
              />
              <Route
                path="/transactions"
                element={
                  <AppRoute>
                    <Factors />
                  </AppRoute>
                }
              />
              <Route
                path="/transactions/factor/:id"
                element={
                  <AppRoute>
                    <FactorPc />
                  </AppRoute>
                }
              />
              <Route
                path="/services"
                element={
                  <AppRoute>
                    <ServicesPagePc />
                  </AppRoute>
                }
              />
              <Route path="/r/*" element={<QuickLoginRedirectPage />} />
              <Route
                path="/reports"
                element={
                  <AppRoute>
                    <ReportsPagePC />
                  </AppRoute>
                }
              />
              <Route
                path="/chat/map"
                element={
                  <AppRoute>
                    <ChatMapPage />
                  </AppRoute>
                }
              />
              <Route
                path="/navigation-popup"
                element={
                  <AppRoute>
                    <OpenNavigationPopupPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/stop"
                element={
                  <AppRoute>
                    <StopReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/speed"
                element={
                  <AppRoute>
                    <SpeedReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/moving"
                element={
                  <AppRoute>
                    <MovingReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/fuel"
                element={
                  <AppRoute>
                    <FuelReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/geo"
                element={
                  <AppRoute>
                    <GeoReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/navigation"
                element={
                  <AppRoute>
                    <NavigationReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/power"
                element={
                  <AppRoute>
                    <PowerReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/reports/standby"
                element={
                  <AppRoute>
                    <StandbyReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/limitations"
                element={
                  <AppRoute>
                    <LimitationsPcReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/limitations/add"
                element={
                  <AppRoute>
                    <LimitationsAddPcReportPage />
                  </AppRoute>
                }
              />
              <Route
                path="/limitations/edit"
                element={
                  <AppRoute>
                    <LimitationsEditPcReportPage />
                  </AppRoute>
                }
              />
              <Route path="/contact-us" element={<SupportPage />} />
              <Route
                path="/reviews"
                element={
                  <AppRoute>
                    <ReviewsPagePC />
                  </AppRoute>
                }
              />

              <Route
                path="/location-history"
                element={
                  <AppRoute>
                    <LocationHistoryMapPage />
                  </AppRoute>
                }
              />
              <Route
                path="/plans"
                element={
                  <AppRoute>
                    <PlansPage />
                  </AppRoute>
                }
              />
              <Route
                path="/online-commands/:IMEI"
                element={<OnlineCommandsPage />}
              />
              <Route path="/other-alerts/:IMEI" element={<OtherAlertsPage />} />
              <Route
                path="/other-settings/:IMEI"
                element={<OtherSettingsPage />}
              />
              <Route path="/pay" element={<PaymentPage />} />
              <Route path="*" element={<Navigate to="/home" replace />} />
              <Route path="/contact-us" element={<SupportPage />} />
            </Routes>
          </Suspense>
        </HomeLayoutPc>
      </>
    );
  }
};

export default RouterPc;
